<template lang="pug">
.payjp-card-and-paypay-form
  p.message
    | お写真を安心してご購入いただけるよう、3D セキュア（本人認証サービス）を導入しています。
    | ご利用時にワンタイムパスワードなどの認証を求められる場合があります。
    | カードがご利用いただけない場合は、ほかのお支払い方法をご検討ください。
  #payment-and-paypay-form
</template>

<script>
export default {
  name: 'PayjpCardAndPaypayForm',

  props: {
    saleId: {
      type: Number,
      required: true,
    },
    // Pay.JPのクライアントシークレット
    clientSecret: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      payments: null,
      widget: null,
    }
  },

  async mounted() {
    this.payments = PayjpPayments(process.env.VUE_APP_PAYJP_PUBLIC_KEY)
    this.widget = this.payments.widgets({
      clientSecret: this.clientSecret,
    })

    // フォームを実際に作成
    this.paymentForm = this.widget.createForm('payment', {
      layout: 'tab',
      paymentMethodOrder: ['card'],
      fields: {
        billingDetails: {
          email: 'never',
          phone: 'never',
        },
      },
    })
    // フォームをマウント
    this.paymentForm.mount('#payment-and-paypay-form')
    // フォームの状態が変わるたびに、完了しているかどうかを親コンポーネントに伝える
    this.paymentForm.on('change', event => {
      this.$emit('changeCardFormIsOK', event.complete)
    })
  },

  beforeDestroy() {
    if (this.paymentForm) {
      // イベントを破棄
      this.paymentForm.off('change')
      // フォームをアンマウント
      this.paymentForm.unmount()
    }
  },

  methods: {
    // 外部から注文の呼び出し用
    async confirmPayment(returnUrl, customerEmail, customerTel) {
      if (!this.widget) {
        console.error('Payjp widget is not initialized')
        return
      }

      const result = await this.widget.confirmPayment({
        return_url: returnUrl,
        payment_method_data: {
          billing_details: {
            email: customerEmail,
            phone: customerTel,
          },
        },
      })
      // カード決済時にエラーが発生した場合は、自動的にreturnUrlに遷移しないので、ここで、エラーが発生した体でreturnUrlに遷移させる
      if (result.error) {
        const paymentFlow = await this.payments.retrievePaymentFlow(this.clientSecret)
        // クエリパラメータを構成して、returnUrlを自ら呼ぶ
        const url = new URL(returnUrl)
        url.searchParams.set('payment_flow_id', paymentFlow.id)
        url.searchParams.set('payment_flow_client_secret', this.clientSecret)
        // returnUrlに遷移
        window.location.href = url.toString()
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../sass/variables.sass'

.payjp-card-and-paypay-form
  .message
    color: #0081c1
    font-size: $size-small
    margin-bottom: 1rem
</style>
